import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.GET_STATUS_SUMMARY,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/getStatusSummary.js